import { Icon } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React, { FunctionComponent } from 'react'

type Props = {
  balance: string
}

export const CashDiscountingBanner: FunctionComponent<Props> = ({
  balance,
}) => {
  return (
    // Can't use helios <Banner> because it's justifies all the text to centre
    <div className="wr-cash-discounting-banner vd-banner vd-banner--info">
      <div className="vd-banner-wrapper vd-flex vd-flex--justify-between">
        <span>
          <Icon icon="fa-info-circle" className="vd-banner-icon"></Icon>
          <T _str="Pay less with cash" _context="Cash discounting banner" />
        </span>
        <span>{balance}</span>
      </div>
    </div>
  )
}
